// Shared image-upload constraints — used by both the profile picture uploader and MyRep Cares.
export const ALLOWED_IMAGE_MIME_TYPES = [
  "image/jpeg",
  "image/png",
  "image/webp",
  "image/heic",
  "image/heif",
];

export const MAX_IMAGE_FILE_SIZE_BYTES = 2 * 1024 * 1024; // 2 MB

export const ALLOWED_IMAGE_ACCEPT =
  "image/jpeg,image/png,image/webp,image/heic,image/heif";
